import React from "react";

const MailIcon = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 4.5H15C15.825 4.5 16.5 5.175 16.5 6V12C16.5 12.825 15.825 13.5 15 13.5H3C2.175 13.5 1.5 12.825 1.5 12V6C1.5 5.175 2.175 4.5 3 4.5ZM3 6V6.315L9 9.75L15 6.315V6H3ZM15 12V8.04L9.372 11.25H8.628L3 8.04V12H15Z"
      fill={color}
    />
  </svg>
);

export { MailIcon };
